// frontend/src/contexts/HomePageHeaderContext.jsx
// Context to pass homepage-specific data to Header for landscape mobile integration

import React, { createContext, useContext } from "react";

const HomePageHeaderContext = createContext(null);

export const useHomePageHeader = () => {
  return useContext(HomePageHeaderContext);
};

export const HomePageHeaderProvider = ({ children, value }) => {
  return (
    <HomePageHeaderContext.Provider value={value}>
      {children}
    </HomePageHeaderContext.Provider>
  );
};

